// Apply to custom properties before the SDK adds its transport/identity fields.
const sensitive = /^(email|email_domain|password|token|access_token|refresh_token|id_token|verification_code|verification_token|reset_token|username|display_name|referral_code|promo_code|user_id|url|share_url|search_query)$/i;
export const privateAutomaticProperties = [
  '$current_url', '$referrer', '$initial_referrer', '$initial_referring_domain',
  '$referring_domain', '$email', '$name',
];
const reasons = new Set([
  'invalid_credentials', 'email_taken', 'invalid_password', 'verification_required',
  'invalid_or_expired_link', 'validation', 'rate_limited', 'network', 'network_error',
  'timeout', 'provider_cancelled', 'provider_error', 'account_conflict', 'server',
  'unknown', 'unknown_error', 'username_taken', 'invalid_username',
  'invalid_referral_code', 'invalid_promo_code',
]);

export const sanitizeAnalyticsProperties = (properties = {}) => Object.entries(properties)
  .reduce((safe, [key, value]) => {
    if (sensitive.test(key) || privateAutomaticProperties.includes(key)) return safe;
    if (/^(error_type|error_code|reason_code)$/.test(key)) {
      return { ...safe, [key]: value == null ? null : (reasons.has(value) ? value : 'unknown') };
    } if (value == null || ['string', 'number', 'boolean'].includes(typeof value)) {
      return { ...safe, [key]: value };
    }
    return safe;
  }, {});

// Transport hook runs after SDK defaults and persisted super-properties merge.
export function sanitizeAnalyticsPayload(payload) {
  const properties = { ...payload.properties };
  privateAutomaticProperties.forEach((key) => { delete properties[key]; });
  // Keep SDK token/$user_id/distinct_id: these are required protocol fields.
  Object.keys(properties).forEach((key) => {
    if (key !== 'token' && sensitive.test(key)) delete properties[key];
  });
  return { ...payload, properties };
}
